var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.wrapperClass},[_c('div',[_c('router-link',{staticClass:"btn revzilla-buy-btn",attrs:{"to":_vm.productTypeURL}},[_c('font-awesome-icon',{attrs:{"icon":_vm.actionIcon}}),_vm._v(" \n          "),_c('strong',[_vm._v("\n             "+_vm._s(_vm.productTypeText)+"\n          ")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }